import React from "react";

const baseStyle = {
  display: "inline-block",
  padding: "2px 8px",
  fontSize: "12px",
  fontWeight: 500,
  borderRadius: "4px",
  border: "1px solid",
  lineHeight: "20px",
  whiteSpace: "nowrap",
};

const colorMap = {
  success: {
    backgroundColor: "#f6ffed",
    color: "#389e0d",
    borderColor: "#b7eb8f",
  },
  error: {
    backgroundColor: "#fff1f0",
    color: "#cf1322",
    borderColor: "#ffa39e",
  },
  warning: {
    backgroundColor: "#fffbe6",
    color: "#d48806",
    borderColor: "#ffe58f",
  },
  info: {
    backgroundColor: "#e6f7ff",
    color: "#096dd9",
    borderColor: "#91d5ff",
  },
  default: {
    backgroundColor: "#fafafa",
    color: "#595959",
    borderColor: "#d9d9d9",
  },
};

function Tag({ children, color = "default", className = "" }) {
  const isCustom = !colorMap[color];
  const customStyle = isCustom
    ? {
        backgroundColor: color,
        color: "#fff",
        borderColor: color,
      }
    : colorMap[color];

  return (
    <span
      style={{
        ...baseStyle,
        ...customStyle,
      }}
      className={className}
    >
      {children}
    </span>
  );
}

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Tag.js